<opac-table>
  <opac-table-row>
    <opac-table-cell-header>
      {{ 'physical.lowerLevel.title' | translate }}
    </opac-table-cell-header>
  </opac-table-row>

  <opac-table-row *ngFor="let item of physicalLowerLevelItemsDisplay">
    <opac-table-cell-text>
      <a [routerLink]="['/info', item.recordId]">
        {{ item.title }}
      </a>
    </opac-table-cell-text>
  </opac-table-row>
</opac-table>

<div *ngIf="physicalLowerLevelItems.length > pageSize" class="show-all-records">
  <opac-button type="text" (click)="isAllItemsDialogOpened = true">
    {{ 'info.physicalRecord.viewAllLowerLevels' | translate }}
  </opac-button>
</div>

<div class="paginator" *ngIf="physicalLowerLevelItems.length > pageSize">
  <mat-paginator
    [length]="physicalLowerLevelItems.length"
    [pageSize]="pageSize"
    (page)="physicalPage($event)"
    [hidePageSize]="true"
    [showFirstLastButtons]="true">
  </mat-paginator>
</div>

<opac-dialog [title]="'physical.lowerLevel.title' | translate" [size]="'full'" [open]="isAllItemsDialogOpened" (closed)="isAllItemsDialogOpened = false">
  <opac-table>
    <opac-table-row>
      <opac-table-cell-header>
        {{ 'physical.lowerLevel.title' | translate }}
      </opac-table-cell-header>
    </opac-table-row>

    <opac-table-row *ngFor="let item of physicalLowerLevelItems">
      <opac-table-cell-text>
        <a [routerLink]="['/info', item.recordId]">
          {{ item.title }}
        </a>
      </opac-table-cell-text>
    </opac-table-row>
  </opac-table>
</opac-dialog>
